import { LogoMark } from "./Icons";

const ITEMS = [
    "Microscopia operatória",
    "Endodontia especializada",
    "Preservação dos dentes naturais",
    "Tecnologia e precisão",
    "Atendimento humanizado",
    "Santos — SP",
];

const Row = ({ hidden }) => (
    <div className="flex shrink-0 items-center" aria-hidden={hidden}>
        {ITEMS.map((item) => (
            <span key={item} className="flex items-center">
                <span className="whitespace-nowrap px-8 font-heading text-sm font-bold uppercase tracking-[0.24em] text-slate-400">
                    {item}
                </span>
                <LogoMark className="h-4 w-4 rounded-[4px] opacity-70" />
            </span>
        ))}
    </div>
);

export const Marquee = () => (
    <div
        className="overflow-hidden border-y border-slate-200/70 bg-white py-5"
        data-testid="editorial-marquee"
    >
        <div className="animate-marquee flex w-max">
            <Row hidden={false} />
            <Row hidden={true} />
        </div>
    </div>
);
